<template>
    <el-row class="rolePermission">
        <el-row class="">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <el-page-header @back="goBack" content="角色权限管理"></el-page-header>
              </div>
              <div class="text item">
                    <el-row>
                        <span>基础设置</span>
                        <el-divider></el-divider>
                        <el-row>
                            <el-form :model="perForm" ref="perForm" label-width="100px">
                                <el-form-item label="权限类型：" prop="type">
                                    <el-select v-model="perForm.type" @change="typeChane">
                                       <el-option v-for="item in datatype"  :label="item.title" :value="item.value" :key="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="权限人：" v-if="isShow"  prop="userArr">
                                    <el-cascader
                                    v-model="perForm.userArr"
                                    :options="roleDatatype"
                                    @change="userChane"></el-cascader>
                                </el-form-item>
                                <el-form-item label="权限组：" v-if="!isShow" prop="group_id">
                                    <el-select v-model="perForm.group_id" @change="grpChange">
                                       <el-option v-for="item in userDatatype"  :label="item.text" :value="item.value" :key="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="描述：" prop="remark">
                                    <el-input type="textarea" v-model="perForm.remark"></el-input>
                                </el-form-item>
                                <el-form-item v-show="false">
                                    <el-button @click="reForm1('perForm')">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </el-row>
                    </el-row>
                    <el-row>
                        <span>权限设置</span>
                        <el-divider></el-divider>
                        <el-row>
                            <el-form :model="checkboxForm" ref="checkboxForm">
                                <el-form-item label="统计：" prop="staticType">
                                    <el-checkbox-group v-model="checkboxForm.staticType">
                                      <el-checkbox label="工单统计" name="type"></el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item label="工单发布：" prop="publishType">
                                    <el-checkbox-group v-model="checkboxForm.publishType">
                                      <el-checkbox label="我的工单" name="type"></el-checkbox>
                                      <el-checkbox label="全部工单" name="type"></el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item label="工单处理：" prop="pengType">
                                    <el-checkbox-group v-model="checkboxForm.pengType">
                                      <el-checkbox label="待受理工单" name="type"></el-checkbox>
                                      <el-checkbox label="我的工单" name="type"></el-checkbox>
                                      <el-checkbox label="全部工单" name="type"></el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item label="系统管理：" prop="sysType">
                                    <el-checkbox-group v-model="checkboxForm.sysType">
                                      <el-checkbox label="角色权限管理" name="type"></el-checkbox>
                                      <el-checkbox label="工单分配逻辑管理" name="type"></el-checkbox>
                                      <el-checkbox label="自动接单管理" name="type"></el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item label="问题库：" prop="qsType">
                                    <el-checkbox-group v-model="checkboxForm.qsType">
                                      <el-checkbox label="问题库" name="type"></el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item class="btn">
                                    <el-button type="primary" @click="keepEvent" v-if="this.$route.params.status == 0?true:false">保存</el-button>
                                    <el-button type="primary" @click="editEvent" v-if="this.$route.params.status == 1?true:false">修改</el-button>
                                    <el-button v-show="false" @click="reForm2('checkboxForm')">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </el-row>
                    </el-row>
              </div>
            </el-card>
        </el-row>
    </el-row>
</template>

<script>
import { getRole,getRoleUser,powerInsert,powerType,powerEdit } from  '../utils/api'
export default {
  components: {},
  props: {},
  data() {
    return {
        isShow:false,
        id:'',
        row:this.$route.params.row,
        power:[],
        perForm:{
            type:'',
            type_name:'',
            remark:'',
            user_id:'',
            user_name:'',
            group_id:'',
            group_name:'',
            userArr:[]
        },
        checkboxForm:{
            publishType:[],
            pengType:[],
            qsType:[],
            sysType:[],
            staticType:[]
        },
        datatype:[],
        userDatatype:[],
        roleDatatype:[],
    };
  },
  watch: {
    "perForm.type"(value){
        if(value == 2){
            this.isShow = true
            // this.perForm.group_id = '';
            // this.perForm.group_name = ''
        }
         if(value == 1){
            this.isShow = false
            // this.perForm.user_id = '';
            // this.perForm.user_name = ''
        }
    }
  },
  computed: {},
  methods: {
    goBack(){
        this.reForm1('perForm')
        this.reForm2('checkboxForm')
        this.$router.go(-1)
    },
    reForm1(form){
        this.$refs[form].resetFields();
    },
    reForm2(form){
        this.$refs[form].resetFields();
    },
    //获取权限类型
    getPowerType(){
        var that = this
        powerType()
        .then(res=>{
            if(res.message.status == 'success'){
                that.datatype = res.data
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },
    //新增
    keepEvent(){
        console.log('保存');
        var that = this
        var power = []
        var pubLeng = that.checkboxForm.publishType.length;
        var penLeng = that.checkboxForm.pengType.length;
        var qsLeng = that.checkboxForm.qsType.length;
        var sysLeng = that.checkboxForm.sysType.length
        var staticLength = that.checkboxForm.staticType.length
        if(staticLength !== 0){
            power.push({
                label:'统计',
                children:that.checkboxForm.staticType
            })
        }
        if(pubLeng !== 0 ){
            console.log('1111111');
            power.push({
                label:'工单发布',
                children:that.checkboxForm.publishType
            })
        } 
        if(penLeng !== 0){
            console.log('22222222');
            power.push({
                label:'工单处理',
                children:that.checkboxForm.pengType
            })
        } 
        if(qsLeng !== 0){
            console.log('33333333');
            power.push({
                label:'问题库管理',
                children:that.checkboxForm.qsType
            })
        } 
        if(sysLeng !== 0){
            console.log('444444444');
            power.push({
                label:'系统管理',
                children:that.checkboxForm.sysType
            })
        }
        that.power = JSON.stringify(power)
        console.log(JSON.stringify(power),'powersssssss');
        var param = {
            type:that.perForm.type,
            type_name:that.perForm.type_name,
            group_id:that.perForm.group_id,
            group_name:that.perForm.group_name,
            user_id:that.perForm.user_id,
            user_name:that.perForm.user_name,
            power:that.power,
            remark:that.perForm.remark
        }
        console.log(param,'params');
        powerInsert(param)
        .then(res=>{
            console.log(res,'添加权限');
            if(res.message.status == 'success'){
                that.$message.success("设置成功")
                that.reForm1('perForm')
                that.reForm2('checkboxForm')
                that.$router.go(-1)
            }else{
                that.$message.error('该选项已存在')
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },
    //编辑
    editEvent(){
        console.log('修改');
        var that = this
        var power = []
        var pubLeng = that.checkboxForm.publishType.length;
        var penLeng = that.checkboxForm.pengType.length;
        var qsLeng = that.checkboxForm.qsType.length;
        var sysLeng = that.checkboxForm.sysType.length;
        var staticLength = that.checkboxForm.staticType.length;
        if(staticLength !== 0){
            power.push({
                label:'统计',
                children:that.checkboxForm.staticType
            })
        }
        if(pubLeng !== 0 ){
            console.log('1111111');
            power.push({
                label:'工单发布',
                children:that.checkboxForm.publishType
            })
        } 
        if(penLeng !== 0){
            console.log('22222222');
            power.push({
                label:'工单处理',
                children:that.checkboxForm.pengType
            })
        } 
        if(qsLeng !== 0){
            console.log('33333333');
            power.push({
                label:'问题库管理',
                children:that.checkboxForm.qsType
            })
        } 
        if(sysLeng !== 0){
            console.log('444444444');
            power.push({
                label:'系统管理',
                children:that.checkboxForm.sysType
            })
        }
        that.power = JSON.stringify(power)
        console.log(JSON.stringify(power),'powersssssss');
        var params = {
            id:that.id,
            type:that.perForm.type,
            type_name:that.perForm.type_name,
            group_id:that.perForm.group_id,
            group_name:that.perForm.group_name,
            user_id:that.perForm.user_id,
            user_name:that.perForm.user_name,
            power:that.power,
            remark:that.perForm.remark
        }
        powerEdit(params)
        .then(res=>{
            console.log(res,'修改权限');
            if(res.message.status == 'success'){
                that.reForm1('perForm')
                that.reForm2('checkboxForm')
                that.$router.go(-1)
            }else{
                that.$message.error('修改失败')
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },
    //获取角色列表
    getRoleTable(){
        var that = this
        getRole()
        .then(res=>{
            if(res.message.status == 'success'){
                console.log(res,'角色列表');
                that.userDatatype = [] //角色
                that.roleDatatype = [] //用户
                res.data.forEach(item=>{
                    that.userDatatype.push({text:item.name,value:item.id})
                    // that.roleDatatype.push({value:item.id,label:item.name})
                })
                // that.roleDatatype.forEach(item=>{
                //     that.getRoleUserTable(item.value)
                // })
                that.roleDatatype = that.$store.state.roleDatatype
                that.$forceUpdate()
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },
    //获取用户列表
    getRoleUserTable(id){
        var that = this
        var params = {
            role_id:id
        }
        var arr = []
        getRoleUser(params)
        .then(res=>{
            if(res.message.status == 'success'){
                if(res.data){
                    res.data.forEach(item=>{
                    arr.push({value:item.userid,label:item.name})
                })
                }
                that.roleDatatype.forEach(item=>{
                    if(item.value == id){
                        item['children'] = arr
                    }
                })
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },
    //角色选择change事件
    grpChange(e){
        var that = this;
        var id = that.perForm.group_id
        that.userDatatype.forEach(item=>{
            if(item.value == id){
                that.perForm.group_name = item.text
            }
        })
    },
    //用户选择change
    userChane(e){
        var that = this;
        that.perForm.user_id = e[1]
        that.perForm.group_id = e[0]
        var params = {
            role_id:e[0]
        }
        getRoleUser(params)
        .then(res=>{
            console.log(res);
            if(res.message.status == 'success'){
                res.data.forEach(item=>{
                    if(item.userid == e[1]){
                        that.perForm.user_name = item.name
                    }
                })
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
        console.log(that.perForm.user_id,'that.perForm.user_id');
        console.log(e,'eeeee');
    },
    typeChane(e){
        console.log(e,'eeeeee');
        var that = this
        that.datatype.forEach(item=>{
            if(item.value == e){
                that.perForm.type_name = item.title
            }
        })
    },
    init(){
        var that = this
        var row = that.$route.params.row
        console.log(row,'row');
        var power = JSON.parse(row.power)
        power.forEach(item=>{
            if(item.label == '工单发布'){
                that.checkboxForm.publishType = item.children
            }else if(item.label == '工单处理'){
                that.checkboxForm.pengType = item.children
            }else if(item.label == '系统管理'){
                that.checkboxForm.sysType = item.children
            }else if(item.label == '问题库管理'){
                that.checkboxForm.qsType = item.children
            }else if(item.label == '统计'){
                that.checkboxForm.staticType = item.children
            }
        })
        if(row.type == '用户权限'){
            that.perForm.type = 2
            that.isShow = true
        }else if(row.type == '组权限'){
            that.perForm.type = 1
            that.isShow = false
        }
        that.perForm.group_id = Number(row.group_id);
        that.perForm.group_name = row.group_name;
        that.perForm.remark = row.remark;
        that.perForm.type_name = row.type_name;
        that.perForm.user_id = row.user_id;
        that.perForm.user_name = row.user_name
        that.id = row.id
        // that.perForm.userArr = [3725841133, '16533874132962935']
        that.perForm.userArr[0] = Number(row.group_id);
        that.perForm.userArr[1] = row.user_id
        console.log(that.perForm.userArr,'that.perForm.userArr');
        // console.log(that.roleDatatype,'that.roleDatatype2222222222');
    }
  },
  created() {},
  mounted() {
  },
  activated(){
    this.getRoleTable() //获取角色
    this.getPowerType() //获取权限类型
    if(this.$route.params.status == 1){
        this.init()
    }
  }
};
</script>
<style lang="scss" scoped>
.btn{
    text-align: center;
    button{
        width: 200px;
    }
}
</style>